import React from 'react'
import { Route } from 'lucide-react'

interface HighwayToggleControlProps {
  showHighways: boolean
  onToggle: () => void
  className?: string
}

export function HighwayToggleControl({
  showHighways,
  onToggle,
  className = ''
}: HighwayToggleControlProps) {
  return (
    <button
      onClick={onToggle}
      className={`${className} mapboxgl-ctrl-icon`}
      aria-label={showHighways ? 'Hide highway overlay' : 'Show highway overlay'}
      title={showHighways ? 'Hide highway overlay' : 'Show highway overlay'}
      style={{
        width: '29px',
        height: '29px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'transparent'
      }}
    >
      <Route
        className="w-4 h-4"
        style={{
          strokeWidth: 2
        }}
      />
    </button>
  )
}
